//----------------------
// <auto-generated>
//     Generated using Aya Client Generator [Version 1.0.2]
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export enum LineOfBusinessEnum {
    PerDiem = 1,
    Travel = 2,
    Locums = 3,
    NonClinical = 4,
    LocalLongTerm = 5,
    Permanent = 6,
    WorkforceDisruptionClinical = 7,
    WorkforceDisruptionNonClinical = 8,
    AccessControl = 9,
    InterimLeadership = 10,
    PayrollServices = 11,
}